<template>
  <div class="background">
    <div class="login-container">
      <div class="login-title">
        <img style="width: 300px; border-radius: 5px;" src="../assets/title.png" alt="">
      </div>
      <el-form :model="loginForm"  class="login-form" :rules="loginRules" ref="loginForm" label-position="top">
      <!-- <h3 class="title">登录</h3> -->
      <el-tabs v-model="activeName" :stretch="true" @tab-click="handleClick" >
        <el-tab-pane label="用户名" name="first">
          <el-form-item prop="account" label="用户名">
            <el-input type="text" v-model="loginForm.account" auto-complete="off" clearable placeholder="用户名"></el-input>
          </el-form-item>
          <el-form-item prop="password" v-if="!phoneLogin" label="密码">
            <el-input type="password" v-model="loginForm.password" auto-complete="off" clearable placeholder="请输入密码"></el-input>        
          </el-form-item>
        </el-tab-pane>
        <el-tab-pane label="手机号" name="second">
          <el-form-item prop="account" label="手机号">
            <el-input type="text" v-model="loginForm.account" auto-complete="off" clearable placeholder="手机号码"></el-input>
          </el-form-item>
          <el-form-item prop="phoneCode" v-if="phoneLogin" label="验证码">
            <el-input type="text" v-model="loginForm.phoneCode" auto-complete="off" clearable placeholder="请输入验证码">
              <el-button slot="append" :disabled="countdown > 0" @click="sendSms">发送
                <span v-if="countdown > 0">({{ countdown }})</span>
              </el-button>
            </el-input>        
          </el-form-item>
        </el-tab-pane>
      </el-tabs>
      <el-form-item style="width: 100%">
        <el-button type="primary" style="width: 100%;background-color: rgb(205, 70, 50);border-color:rgb(205, 70, 50);" @click="handleSubmit" :loading="logining" >登录</el-button>
        <!-- <el-button type="text" @click="switchLogin">{{loginDesc}}</el-button> -->
      </el-form-item>
    </el-form>
    </div>
    <div class="eqcode">
      <div class="eqcode_text">微信扫码打开小程序</div>
      <img class="eqcode_img" src="../assets/eqcode.png" alt="">
    </div>
  </div>
</template>
  
<script>
import { login,sendVerifyCode } from '@/api/account';
import { encode,getCurrentTime,validatePhoneNumber } from '@/utils/kits';
import { storeAccount } from '@/cookie';
import { Message,Notification } from 'element-ui';

export default {
  data() {
    return {
      activeName:'first',
      logining: false,
      imgBgSre : require('@/assets/bg.jpeg'),
      phoneLogin: false,
      loginDesc: '手机登录',
      loginForm: {
        account: "",
        password: "",
        phoneCode: "",
      },
      loginRules: {
        account: [
          { required: true, message: "请输入账户", trigger: "blur" },
          //{ pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
        ],
        phoneCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
      },
      countdown: 0, // 倒计时秒数
      intervalId: null, // 存储interval的id
      countdownSeconds: 300, // 倒计时总秒数
    };
  },
  mounted(){
     window.addEventListener('keyup', this.handleKeyEvent);
  },
  methods: {
    handleClick(tab, even){
      console.log("ssssssssss",tab.name);
      if (tab.name === "first") {
        this.phoneLogin = false;
      }else if(tab){
        this.phoneLogin = true;
      }
    },
    //按键
    handleKeyEvent(event) {
      if (event.key === 'Enter') {
          this.handleSubmit();
      }
    },
    //切换登录方式
    // switchLogin(){
    //   if(this.phoneLogin){
    //      this.phoneLogin = false;
    //      this.loginDesc = '手机登录';
    //   } else {
    //      this.phoneLogin = true;
    //      this.loginDesc = '密码登录';
    //   }
    // },

    //登录按钮触发
    handleSubmit() {
      var _this = this;
      this.$refs.loginForm.validate((valid) => {
          if(valid){
              let ub64 = _this.getAccoutEncodeText();
              let pb64 = _this.getPwdEncodeText();
              let params = {
                username: ub64,
                password: pb64,
                code: _this.loginForm.phoneCode,
                phoneLogin: _this.phoneLogin,
                encode: true
              }
              if(_this.phoneLogin){
                let accout_0 = _this.loginForm.account;
                if(!validatePhoneNumber(accout_0)){
                   Message.error('账户必须是手机号码');
                   return; 
                }
              }
              _this.logining = true;
              login(params).then(res => {
                  _this.logining = false;
                  if(res.code == 200){
                     localStorage.setItem('USERINFO', JSON.stringify(res.data));
                     storeAccount(res.data);
                     _this.$router.push({ path : '/'});
                  } else {
                     Message.error(res.msg);
                  }
              });
          }
      });
    },

    //发送验证码
    sendSms(){
      var _this = this;
      this.$refs.loginForm.validateField('account',(varMsg) => {
        if(varMsg == ''){
          let accout_0 = _this.loginForm.account;
          if(!validatePhoneNumber(accout_0)){
              Message.error('账户必须是手机号码');
              return; 
          }
          let ub64 = _this.getAccoutEncodeText();
          let params = {username: ub64,encode: true}
          sendVerifyCode(params).then(res => {
              if(res.code == 200){
                  Message.success('验证码发送成功'); 
                  _this.startCountdown();
              } else {
                  Message.warning(res.msg);
              }
          });
        }
      });
    },

    //倒计时
    startCountdown() {
      if (this.countdown > 0) return; // 如果倒计时正在进行，则不再启动

      this.countdown = this.countdownSeconds;
      this.intervalId = setInterval(() => {
        if (this.countdown > 0) {
            this.countdown -= 1;
        } else {
            clearInterval(this.intervalId);
        }
      }, 1000);
    },

    //跳转到注册
    goRegister(){
      this.$router.push({path:'/register'});
    },

    //获取账户
    getAccoutEncodeText(){
        let random_ = Math.random() * (9999 - 1000) + 1000;
        let accout_ = this.loginForm.account;
        let currentDate = getCurrentTime();
        let ub64 = encode('@' + currentDate + '@' + accout_ + '@' + random_);
        return ub64;
    },

    //获取密码
    getPwdEncodeText(){
        if(this.phoneLogin){
            return '';
        }
        let password_ = this.loginForm.password;
        let random_   = Math.random() * (9999 - 1000) + 1000;
        let currentDate = getCurrentTime();
        let ub64 = encode('@' + currentDate + '@' + password_ + '@' + random_);
        return ub64;
    },

  },
};
</script>

<style scoped>
.background{  
    height:100vh;  
    position: relative;
    background-image: url('../assets/bg.jpeg');
    background-repeat: no-repeat;
    background-size: cover;
}

.login-container {
  position: absolute;
  top: 22%;
  left: calc(80% - 240px);
  padding: 60px 50px;
  box-sizing: border-box;
  width: 400px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 15px;
  .title {
    margin: 0px auto 40px auto;
    text-align: center;
    color: #505458;
  }
  .remember {
    margin: 0px 0px 35px 0px;
  }
}
.login-title {
  margin-bottom: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}
::v-deep .el-form-item__label{
  line-height: 20px;
}
.eqcode{
  position: fixed;
  bottom: 20px;
  right: 40px;
}
.eqcode_text{
  width: 140px;
  text-align: center;
  color: #fff;
  font-size: 14px;
  margin-bottom: 10px;
}
.eqcode_img{
  width: 140px;
  height: 140px;
}
</style>


// WEBPACK FOOTER //
// src/views/Login.vue